<template>
  <div class="infinite-wrapper">
    <slot></slot>
    <div class="infinite-status" v-if="statusVisible">
      <p class="infinite-loading" v-show="loading">{{ loadingText }}</p>
      <p class="infinite-nothing" v-show="!loading && completed && list.length === 0">{{ nothingText }}</p>
      <p class="infinite-completed" v-show="!loading && completed && list.length > 0">{{ completedText }}</p>
    </div>
  </div>
</template>
<script>
import { isScrollToPageBottom } from '@/utils/utils';
import { throttle } from 'throttle-debounce';
export default {
  name: 'InfiniteLoading',
  props: {
    // 数据列表
    list: Array,
    // 数据加载状态
    loading: Boolean,
    // 数据全部加载完毕状态
    completed: Boolean,
    // 是否立即触发
    immediate: Boolean,
    // 距离底部多少像素时触发无限加载
    distance: { type: String, default: '500px' },
    // 加载中文字
    loadingText: { type: String, default: '加载中...' },
    // 加载完成文字
    completedText: { type: String, default: '没有更多内容了' },
    // 无数据时的文字
    nothingText: { type: String, default: '暂时没有数据' },
    // 是否显示加载状态
    statusVisible: { type: Boolean, default: true },
  },
  mounted() {
    //this.immediate && this.onPageScroll();
    if( this.immediate ) {
      this.$emit('infinite');
    }

    window.addEventListener('scroll', this.onPageScroll, false);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('scroll', this.onPageScroll, false);
    });
  },
  methods: {
    /**
     * 页面发生滚动时
     */
    onPageScroll: throttle(200, false, function() {
      const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      this.$emit('scroll', scrollTop);

      isScrollToPageBottom(parseInt(this.distance)) && this.$emit('infinite');
    }),
  },
};
</script>
<style lang="scss" scoped>
.infinite-status {
  padding: 50px 0;
  text-align: center;
  font-size: 20px;
  line-height: 28px;
  color: #999999;
}
</style>
